import {
  LayoutDashboard,
  Users,
  ShieldCheck,
  Users2,
  Calendar,
  Trophy,
  MessageSquare,
  Shield,
  GraduationCap,
  Newspaper,
  Database,
  Settings,
  Activity,
  Bell,
  FileText,
  Server,
  Scale,
  Code2,
  Rss,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  id: string;
  label: string;
  icon: LucideIcon;
  path?: string;
  children?: NavItem[];
  badge?: number | string;
}

export interface NavSection {
  id: string;
  title: string;
  items: NavItem[];
}

export const sidebarConfig: NavSection[] = [
  {
    id: 'main',
    title: 'Main',
    items: [
      {
        id: 'dashboard',
        label: 'Dashboard',
        icon: LayoutDashboard,
        path: '/dashboard',
      },
    ],
  },
  {
    id: 'users',
    title: 'User Management',
    items: [
      {
        id: 'users',
        label: 'Users',
        icon: Users,
        children: [
          { id: 'users-all', label: 'All Users', icon: Users, path: '/users' },
          { id: 'users-verification', label: 'Verification', icon: ShieldCheck, path: '/users/verification' },
          { id: 'users-blocked', label: 'Blocked', icon: Shield, path: '/users/blocked' },
          { id: 'users-reports', label: 'Reports', icon: FileText, path: '/users/reports' },
        ],
      },
      {
        id: 'admins',
        label: 'Admin Users',
        icon: ShieldCheck,
        children: [
          { id: 'admins-accounts', label: 'Accounts', icon: ShieldCheck, path: '/admins' },
          { id: 'admins-roles', label: 'Roles', icon: Shield, path: '/admins/roles' },
        ],
      },
    ],
  },
  {
    id: 'squads-play',
    title: 'Squads & Play',
    items: [
      {
        id: 'squads',
        label: 'Squads',
        icon: Users2,
        children: [
          { id: 'squads-all', label: 'All Squads', icon: Users2, path: '/squads' },
          { id: 'squads-members', label: 'Memberships', icon: Users, path: '/squads/memberships' },
          { id: 'squads-moderation', label: 'Moderation', icon: Shield, path: '/squads/moderation' },
        ],
      },
      {
        id: 'sessions',
        label: 'Sessions',
        icon: Calendar,
        children: [
          { id: 'sessions-scheduled', label: 'Scheduled', icon: Calendar, path: '/sessions' },
          { id: 'sessions-active', label: 'Active', icon: Activity, path: '/sessions/active' },
          { id: 'sessions-history', label: 'History', icon: FileText, path: '/sessions/history' },
        ],
      },
      {
        id: 'matches',
        label: 'Matches',
        icon: Trophy,
        children: [
          { id: 'matches-live', label: 'Live', icon: Activity, path: '/matches/live' },
          { id: 'matches-history', label: 'History', icon: Trophy, path: '/matches' },
        ],
      },
    ],
  },
  {
    id: 'chat-moderation',
    title: 'Chat & Moderation',
    items: [
      {
        id: 'messages',
        label: 'Messages',
        icon: MessageSquare,
        children: [
          { id: 'messages-squads', label: 'Squad Chats', icon: MessageSquare, path: '/messages/squads' },
          { id: 'messages-dms', label: 'Direct Messages', icon: MessageSquare, path: '/messages/dms' },
          { id: 'messages-flagged', label: 'Flagged', icon: Shield, path: '/messages/flagged' },
        ],
      },
      {
        id: 'moderation',
        label: 'Moderation',
        icon: Shield,
        children: [
          { id: 'moderation-queue', label: 'Queue', icon: FileText, path: '/moderation/queue' },
          { id: 'moderation-actions', label: 'Actions', icon: Shield, path: '/moderation/actions' },
        ],
      },
    ],
  },
  {
    id: 'academy',
    title: 'Academy',
    items: [
      {
        id: 'providers',
        label: 'Providers',
        icon: GraduationCap,
        children: [
          { id: 'providers-review', label: 'Review Queue', icon: Shield, path: '/providers/review' },
          { id: 'providers-coaches', label: 'Coaches', icon: GraduationCap, path: '/providers/coaches' },
          { id: 'providers-academies', label: 'Academies', icon: GraduationCap, path: '/providers/academies' },
          { id: 'providers-stringers', label: 'Stringers', icon: GraduationCap, path: '/providers/stringers' },
        ],
      },
      {
        id: 'certifications',
        label: 'Certifications',
        icon: ShieldCheck,
        path: '/certifications',
      },
    ],
  },
  {
    id: 'content',
    title: 'Content',
    items: [
      {
        id: 'feed-management',
        label: 'Homepage Feed',
        icon: Rss,
        path: '/content/feed',
      },
      {
        id: 'buzz',
        label: 'Buzz',
        icon: Newspaper,
        children: [
          { id: 'buzz-articles', label: 'Articles', icon: Newspaper, path: '/buzz/articles' },
          { id: 'buzz-events', label: 'Events', icon: Calendar, path: '/buzz/events' },
          { id: 'buzz-promos', label: 'Promos', icon: Bell, path: '/buzz/promos' },
        ],
      },
    ],
  },
  {
    id: 'reference',
    title: 'Reference Data',
    items: [
      {
        id: 'zip-master',
        label: 'ZIP Master',
        icon: Database,
        children: [
          { id: 'zip-master-seed', label: 'Seed Data', icon: Database, path: '/reference/zip-master/seed' },
          { id: 'zip-master-list', label: 'View List', icon: Database, path: '/reference/zip-master' },
        ],
      },
      {
        id: 'courts',
        label: 'Courts',
        icon: Database,
        path: '/reference/courts',
      },
      {
        id: 'play-formats',
        label: 'Play Formats',
        icon: Database,
        path: '/reference/play-formats',
      },
    ],
  },
  {
    id: 'system',
    title: 'System',
    items: [
      {
        id: 'sql-editor',
        label: 'MySQL',
        icon: Database,
        path: '/system/sql-editor',
      },
      {
        id: 'dynamodb',
        label: 'DynamoDB',
        icon: Database,
        path: '/system/dynamodb',
      },
      {
        id: 'audit-log',
        label: 'Audit Log',
        icon: Shield,
        path: '/system/audit-log',
      },
      {
        id: 'compliance',
        label: 'Compliance',
        icon: Scale,
        path: '/system/compliance',
      },
      {
        id: 'api-docs',
        label: 'API Docs',
        icon: Code2,
        path: '/system/api-docs',
      },
      {
        id: 'health',
        label: 'Health',
        icon: Activity,
        path: '/system/health',
      },
      {
        id: 'jobs',
        label: 'Jobs',
        icon: Server,
        path: '/system/jobs',
      },
      {
        id: 'push',
        label: 'Push',
        icon: Bell,
        path: '/system/push',
      },
      {
        id: 'logs',
        label: 'Logs',
        icon: FileText,
        path: '/system/logs',
      },
      {
        id: 'settings',
        label: 'Settings',
        icon: Settings,
        path: '/system/settings',
      },
    ],
  },
];
